const reduceFields = fields =>
  fields.reduce((map, field) => {
    if (field.value === null || typeof field.value === 'undefined') {
      map[field.id] = field.fields
    } else if (field.fieldType === 'Assets') {
      map[field.id] = { altText: field.alternateText, src: field.imgURL }
    } else if (field.fieldType === 'Matrix') {
      map[field.id] = reduceFields(field.fields)
    } else {
      map[field.id] = field.value
    }

    return map
  }, {})

export default reduceFields



// WEBPACK FOOTER //
// ./src/utils/fieldsArrayToKeyValueHash.js